import { Fragment } from "react";
import { BrowserRouter,Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Signin from "../pages/Signin";
import Signup from "../pages/Signup";
import useAuth from "../hooks/useAuth.js"
import Changepassword from "../pages/Changepassword/index.js";

const Private = ({Item}) => {
    const {signed} = useAuth();
  
    return signed > 0 ? <Item /> : <Signin />
}

const RoutesApp = () => {
    return (
        <BrowserRouter>
            <Fragment>
                <Routes>
                    {/* <Route exact path="/home" element={<Private Item={Home} />} /> */}
                    <Route path="/" element={<Home/>}/>
                    <Route path="/login" element={<Signin />} />
                    <Route exact path="/signup" element={<Signup />} />
                    <Route exact path="/changepassword" element={<Changepassword />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </Fragment>
        </BrowserRouter>
    )
}

export default RoutesApp